/* jshint esversion: 6 */
import React from 'react';
import Loading from 'app/components/common/Loading.jsx';
import PostImage from 'app/components/common/PostImage.jsx';
import EmblaCarousel from 'app/components/common/EmblaCarousel.jsx';
import Utilities from 'app/utility/Utilities.js';
import EverqueuePlaceholder from 'app/components/common/EverqueuePlaceholder.jsx';
import DeleteModal from 'app/components/common/DeleteModal.jsx';

class CalendarDetailDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            drawerDate: null,
            posts: [],
            isLoading: false
        };

        this.drawerRef = React.createRef();
        this.getCalendarDetail = this.getCalendarDetail.bind(this);
        this.detailActionHandler = this.detailActionHandler.bind(this);
        this.interactionCheck = this.interactionCheck.bind(this);
        this.deleteItem = this.deleteItem.bind(this);

    }

    componentDidMount() {

        this.getCalendarDetail();

        // set state drawerDate to keep the display stable
        // when closing the drawer
        this.setState({
            drawerDate: this.props.drawerDate
        });

        document.addEventListener('mouseup', this.interactionCheck);
        document.addEventListener('touchend', this.interactionCheck);

    }

    componentWillUnmount() {

        document.removeEventListener('mouseup', this.interactionCheck);
        document.removeEventListener('touchend', this.interactionCheck);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps && prevProps.app.loading.QUEUE_CALENDAR_DETAIL === true && this.props.app.loading.QUEUE_CALENDAR_DETAIL === false) {
            let posts = Utilities.deepClone(this.props.queue.calendar.detail),
                validPosts = [];

            if (this.props.currentFilter !== '') {
                posts.map((post) => {
                    let validPost = false;

                    if (this.props.isPostOfType(post, this.props.currentFilter)) {
                        validPosts.push(post);
                    }
                })
            } else {
                validPosts = posts;
            }

            this.setState({
                posts: validPosts,
                isLoading: false
            });
        }

        if (prevProps && prevProps.drawerDate !== this.props.drawerDate) {
            this.getCalendarDetail();
            // set state drawerDate to keep the display stable
            // when closing the drawer
            if (this.props.drawerDate) {
                this.setState({
                    drawerDate: this.props.drawerDate
                });
            }
        }

    }

    interactionCheck(e) {

        if ((this.drawerRef.current && this.drawerRef.current.contains(e.target))) {
            return;
        } else {
            this.props.showDrawer(false);
        }

    }

    getCalendarDetail() {
        if (this.props.drawerDate !== undefined && this.props.drawerDate !== null) {

            let startTs = new moment(this.props.drawerDate).tz(this.props.user.detail.timezone).hours(0).minutes(0).format('X'),
                endTs = new moment(this.props.drawerDate).tz(this.props.user.detail.timezone).hours(23).minutes(59).seconds(59).format('X');

            this.props.getCalendarDetail({
                socialId: this.props.social.id,
                startTs: parseInt(startTs),
                endTs: parseInt(endTs)
            });

            this.setState({
                isLoading: true
            });

        }
    }

    detailActionHandler(e) {
        let index = parseInt(e.currentTarget.dataset.index),
            action = e.currentTarget.dataset.action;

        if (this.state.posts[index]) {
            let post = this.state.posts[index];

            if (action === 'edit') {
                this.props.persistData("queueItem", post);
            } else if (action === 'reshare') {
                this.props.persistData("repostItem", post);
            } else if (action === 'delete') {
                this.deleteItem(post.id);
                return;
            }

            this.props.router.navigate("/content/post");

        }

    }

    deleteItem(id) {
        let cancelAction = () => {
            this.props.closeAllModals();
        },
        confirmAction = (e) => {
            e.preventDefault();
            this.props.deleteQueue(this.props.social.id, [id], false);
            this.props.closeAllModals();
        },
        modal = (
            <DeleteModal
                modalCopy="Are you sure you want to remove this item?"
                cancelAction={cancelAction}
                confirmAction={confirmAction} />
        );

        this.props.addModal(modal);

    }

    render() {
        let drawerContent = null;

        if (this.state.isLoading) {
            drawerContent = (
                <Loading/>
            );
        } else if (this.state.isLoading === false && this.state.posts.length === 0) {
            let imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

            drawerContent = (
                <ul className="calendar-post-list">
                    <li className="calendar-post-item">
                        <div className="day-empty">
                            <img src={`${imageUrl}/misc/calendar-emptystate.svg`} width="125"/>
                            <div className="header-content">
                                No scheduled posts for today
                            </div>
                            <div className="body-content">
                                Posting regularly is an easy way to grow your reach and engagement.
                            </div>
                            <div className="day-empty-button" onClick={(e) => {
                                e.preventDefault();

                                this.props.persistData('scheduleDate', JSON.stringify({
                                    date: this.props.drawerDate.toDate(),
                                    hasHour: false,
                                    source: encodeURIComponent(window.location.href)
                                }));
                                if (this.props.social && this.props.social.id) {
                                    this.props.router.navigate(`/content/post?id=${this.props.social.id}`);
                                } else {
                                    this.props.router.navigate(`/content/post`);
                                }

                            }}>
                                Schedule Post
                            </div>
                        </div>
                    </li>
                </ul>
            );
        } else {
            drawerContent = (
                <ul className="calendar-post-list">
                    {this.state.posts.map((post, i) => {
                        let postCopy = '',
                            link = '',
                            previewImage = null,
                            actionButtons = null,
                            postIcon = null,
                            sourceClass = '',
                            postTime = new moment(post.queuetime).tz(this.props.user.detail.timezone).format('h:mm a');


                        if (post.preview.title) {
                            postCopy = post.preview.title;
                        } else if (post.preview.itemInfo !== undefined && post.preview.itemInfo.title) {
                            postCopy = post.preview.itemInfo.title;
                        } else if (post.preview.itemInfo !== undefined && post.preview.itemInfo.summary) {
                            postCopy = post.preview.itemInfo.summary;
                        } else if (post.preview.message !== undefined && post.preview.message) {
                            postCopy = post.preview.message;
                        }

                        if (post.preview.link !== undefined && post.preview.link) {
                            link = post.preview.link;
                        }

                        if ((post.preview.media && post.preview.media.length) || (post.preview.itemInfo && post.preview.itemInfo.imageThumbLink !== undefined)) {
                            if (post.preview.media && post.preview.media.length > 1) {
                                previewImage = (
                                    <EmblaCarousel options={{
                                            container: ".carousel-slide-wrapper",
                                            slide: ".carousel-slide",
                                            align: 'start',
                                            loop: true
                                        }}
                                        extraClasses={'calendar'}
                                        mode='calendar-view'>
                                        {post.preview.media.map((media, j) => {
                                            return(
                                                <PostImage
                                                    {...this.props}
                                                    key={`calendar-item-${i}-image-${j}`}
                                                    src={media.thumb}/>
                                            );
                                        })}
                                    </EmblaCarousel>
                                )
                            } else {
                                previewImage = (
                                    <PostImage
                                        {...this.props}
                                        item={post}/>
                                );
                            }
                        }

                        if (post.canEdit === 1 || (post.canEdit === 0 && new moment(post.queuetime) < new moment())) {
                            let buttons = [{
                                icon: 'fa fa-share fa-lg',
                                ariaLabel: 'Reshare this item',
                                action: 'reshare'
                            }];

                           

                            if (post.canEdit === 1) {
                                buttons = [{
                                        icon: 'icon ion-ios-compose-outline',
                                        ariaLabel: 'Edit this item',
                                        action: 'edit',
                                    }, {
                                        icon: 'icon ion-ios-trash-outline',
                                        ariaLabel: 'Delete this item',
                                        action: 'delete'
                                    }
                                ];
                            } else if (post.canEdit === 0 && new moment(post.queuetime) < new moment()) {
                                postTime = `Posted at: ${postTime}`;
                            }

                            actionButtons = (
                                <div className="calendar-detail-actions">
                                    {buttons.map((button) => {
                                        return (
                                            <div className="calendar-detail-action"
                                                key={button.action}
                                                role="button"
                                                aria-label={button.ariaLabel}
                                                onClick={this.detailActionHandler}
                                                data-index={i}
                                                data-action={button.action}>
                                                <i className={button.icon}/>
                                            </div>
                                        )
                                    })}
                                </div>
                            );
                        }

                        [postIcon, sourceClass] = this.props.getSourceIcon(post.dlvrSrc);

                        if (sourceClass === 'everqueue') {
                            previewImage = <EverqueuePlaceholder/>
                        }

                        return (
                            <li key={`calendar-post-${i}`} className="calendar-post-item">
                                <div className="calendar-post">
                                    <div className="post-content">
                                        <div className="post-body-wrapper">
                                            {previewImage !== null ? (
                                                <div className="post-image">
                                                    {previewImage}
                                                </div>
                                            ) : null}
                                            <div className="post-copy">
                                                {postCopy}
                                            </div>
                                        </div>
                                        <div className="post-link">
                                            {link}
                                        </div>
                                    </div>
                                    <div className="post-status">
                                        <div className="post-time">
                                            {postIcon} <span className="time-display">{postTime}</span>
                                        </div>
                                        <div className="post-controls">
                                            {actionButtons}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )
        }

        return (
            <div className="drawer-inner-container" ref={this.drawerRef}>
                <div className="drawer-header">
                    <div className="date-cell">
                        <div className="date-controls">
                            <div className="date-chooser">
                                <div className="prev-button nav-button" arial-label="Previous Day" onClick={() => {
                                    let yesterday = new moment(this.state.drawerDate).subtract(1, 'day');
                                    this.props.setDrawerDate(yesterday);
                                }}>
                                    <i className="fa fa-chevron-circle-left"/>
                                </div>
                                <div className="date-label">{new moment(this.state.drawerDate).format('ddd, MMM Do')}</div>
                                <div className="next-button nav-button" arial-label="Next Day" onClick={() => {
                                    let tomorrow = new moment(this.state.drawerDate).add(1, 'day');
                                    this.props.setDrawerDate(tomorrow);
                                }}>
                                    <i className="fa fa-chevron-circle-right"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="close-cell">
                        <div className="close-button" role="button" aria-label="close detail" onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            this.props.showDrawer(false);
                        }}>
                            <i className="icon ion-android-close"/>
                        </div>
                    </div>
                </div>
                <div className="drawer-content">
                    {drawerContent}
                </div>
            </div>
        )
    }
}

export default CalendarDetailDrawer;
